/**
 * Calculator3 JS controller. (Apurahansaajan Mela-turva)
 *
 * This class handles processing of third calculator form.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Calculator3. This gets mapped with the keyword Calculator3 and its
 * docready method is fired automatically on pages where there's a
 * class called 'Calculator3' on the html tag.
 */
class Calculator3 {

    /**
     * The class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the methods
     */
    cache() {

        // Instance of the Calculators utility class.
        this.utils = Theme.getController( 'Calculators' );

        // Store a shorthand reference to translatable strings.
        this.strings = themeData.themeStrings.calculators;

        // Calculator form.
        this.$form = this.utils.initForm( 'apurahansaajan-mela-turva' );

    }

    /**
     * All dom events of the class.
     * @return {void}
     */
    events() {

        // Bind a handler to form submit.
        this.$form.on( 'submit', e => this.calculateForm( e ) );

        // Prevent native HTML validation
        this.$form[0].noValidate = true;

        // Auto-submit the form? See Calculators class for details.
        if ( this.$form.data( 'submit' ) ) {
            this.$form.trigger( 'submit' );
        }

    }

    /**
     * Processing function for the form.
     *
     * @param {object} e Event object.
     */
    calculateForm( e ) {

        // Stop propagation
        Theme.Common.stop( e );

        // Placeholder for calculated data.
        this.calculatedData = {
            'rows': {
                'yearly_income': null,
                'myel_insurance_cost': [
                    null,
                    'eur_per_year'
                ],
                'myel_insurance_cost_increased': [
                    null,
                    'eur_per_year'
                ],
                'work_mata_insurance_cost': [
                    null,
                    'eur_per_year'
                ],
                'leisure_mata_insurance_cost': [
                    null,
                    'eur_per_year'
                ],
                'group_life_insurance_cost': null,
                'mela_sickness_benefit': [
                    null,
                    'eur_per_day'
                ],
                'mata_benefit': [
                    null,
                    'eur_per_day'
                ]
            },
            'pension_graph': {
            }
        };

        // Validate and store form values in class property validatedData.
        this.validatedData = this.utils.validateForm( this.$form, {
            'birth_year': 0,         // int >=0
            'birth_month': 0,        // int 1-12
            'gender': 0,             // int 0-1 (0 = female, 1 = male)
            'grant_sum': 0,          // float >=0 (EUR)
            'expenses': 0,           // float >=0 (EUR)
            'duration': 0           // int >=4 (months)
        });

        // Calculate yearly income.
        this.calculatedData.rows['yearly_income'] = ( ( this.validatedData['grant_sum'] - this.validatedData.expenses ) * 12 ) / this.validatedData.duration;
        this.calculatedData.rows['yearly_income'] = this.utils.round( this.calculatedData.rows['yearly_income'], 2 );

        // Calculate MYEL insurance cost and the type of it (normal or increased, based on the
        // age calculated from birth year).
        const MYELInsurance = this.utils.calculateMYELInsurance(
            this.calculatedData.rows['yearly_income'],
            this.validatedData.birth_year,
            this.validatedData.birth_month,
            this.validatedData.duration
        );
        this.calculatedData.rows['myel_insurance_cost' + ( MYELInsurance[1] ? '_increased' : '' ) ] = [
            MYELInsurance[0],
            MYELInsurance[2]
        ];

        // Calculate work time MATA insurance.
        const MATAInsurance = this.utils.calculateMATAInsurance(
            this.calculatedData.rows['yearly_income'],
            0,
            3,
            this.validatedData.duration,
            2,
            4.00
        );
        this.calculatedData.rows['work_mata_insurance_cost'] = [
            MATAInsurance[0],
            MATAInsurance[1]
        ];

        // Calculate leisure time MATA insurance.
        const leisureMATAInsurance = this.utils.calculateLeisureMATAInsurance(
            this.calculatedData.rows['yearly_income'],
            true,
            this.validatedData.duration
        );
        this.calculatedData.rows['leisure_mata_insurance_cost'] = [
            leisureMATAInsurance[0],
            leisureMATAInsurance[1]
        ];

        // Group life insurance cost.
        this.calculatedData.rows['group_life_insurance_cost'] = this.utils.adjustValueForTimePeriod(
            this.utils.groupLifeInsuranceCostBeneficiaries,
            this.validatedData.duration
        );

        // Calculate MELA sickness benefit.
        this.calculatedData.rows['mela_sickness_benefit'][0] = this.utils.calculateMELASicknessBenefit(
            this.calculatedData.rows['yearly_income']
        );

        // Calculate MATA benefit per day.
        this.calculatedData.rows['mata_benefit'][0] = this.utils.calculateMATABenefit(
            this.calculatedData.rows['yearly_income'],
            true
        );

        // Calculate pension.
        this.calculatedData['pension_graph'] = this.utils.calculatePension(
            this.calculatedData.rows['yearly_income'],
            0,
            this.validatedData.accumulated_pension,
            this.validatedData.birth_year,
            this.validatedData.birth_month
        );

        // Additional notes.
        if ( this.calculatedData.rows['yearly_income'] <= this.utils.yearlyMinIncome ) {
            this.utils.dataNotes[ 'leisure_mata_insurance_cost' ] = this.strings.calculator_note_1;
            this.utils.dataNotes[ 'mata_benefit' ] = this.strings.calculator_note_1;
        }

        // Render output.
        this.outputForm();
    }

    /**
     * Render output for the first form.
     */
    outputForm() {

        // Stop here if errors were found.
        if ( this.utils.validator.errorLog.length ) {
            this.utils.outputErrors( this.$form );
            return false;
        }

        // Create container for output.
        const $container = this.utils.renderResultsContainer( this.$form );

        // Add calculation parameters.
        const $params = this.utils.renderParams(
            this.$form,
            this.validatedData,
            {
                'grant_sum': {
                    'ext': 'eur'
                },
                'expenses': {
                    'ext': 'eur'
                },
                'duration': {
                    'ext': 'mo'
                },
                'accumulated_pension': {
                    'ext': 'eur_per_month'
                }
            }
        );
        $params.appendTo( $container );

        // Create and insert results after the form. Use 2 decimal places for numeric values.
        const $table = this.utils.renderData( this.calculatedData.rows, 2 );
        $table.appendTo( $container );

        const birthYear  = this.validatedData.birth_year;
        const birthMonth = this.validatedData.birth_month;
        const grantSum   = this.validatedData.grant_sum;
        const expenses   = this.validatedData.expenses;
        const duration   = this.validatedData.duration;
        const gender     = this.validatedData.gender;

        const earnings = ( grantSum - expenses ) / duration * 12; // Työtulo.

        const pensionYear = this.utils.calculatePensionStartYear( birthYear, birthMonth );

        let yearsInPension = 0;

        let lowestPensionAge = this.utils.pensionParameters[birthYear][0];

        // Round to nearest five if is not a 'ten' number. e.g. 15 => 20, 41 => 45, 20 => 20.
        const roundPensionYear = ( pensionYear % 10 == 0 ) ? pensionYear : pensionYear - pensionYear % 5 + 5;

        const lowestPensionYear = lowestPensionAge.slice( 0, 2 );

        if ( parseInt( gender ) == 0 ) {
            yearsInPension = this.utils.lifeExpectancyFemales[lowestPensionYear][roundPensionYear];
        } else {
            yearsInPension = this.utils.lifeExpectancyMales[lowestPensionYear][roundPensionYear];
        }

        let r = 0.015; // 1,5%

        if ( 2020 - birthYear > 52 && 2020 - birthYear < 63 ) {
            r = 0.017; // 1,7%
        }

        const monthlyPension =  this.utils.round( earnings / 12 * r * duration / 12 );

        let pensionAmount = monthlyPension * 12 * yearsInPension;
        pensionAmount     = this.utils.format( pensionAmount, 2 );

        let yearsInPensionFormatted = this.utils.format( yearsInPension, 1 );

        lowestPensionAge = this.utils.maybeDateFormat( lowestPensionAge );

        // Swedish replacements.
        lowestPensionAge = lowestPensionAge.replace( 'år', 'år och' ).replace( 'mån', 'månader' );

        // English replacements.
        lowestPensionAge = lowestPensionAge.replace( 'y', 'and' ).replace( 'm', 'months' );

        const infoText = this.strings.apuraha_result_1.replace( '%1$s', lowestPensionAge ).replace( '%2$s', pensionYear ).replace( '%3$s', monthlyPension ) + ' ' + this.strings.according_to + ' <a href="https://ec.europa.eu/eurostat/databrowser/view/PROJ_19NALEXP__custom_4325809/default/table?lang=en" target="_blank" rel="nonopener noreferrer">' + this.strings.life_expectancy + '</a> ' + this.strings.apuraha_result_2.replace( '%1$s', yearsInPensionFormatted ).replace( '%2$s', pensionAmount );

        const $resultsInfoText = $( '<br><p>' + infoText + '</p>' );

        $resultsInfoText.appendTo( $container );

        // Append action buttons.
        const $buttons = this.utils.renderButtons( this.$form );
        $buttons.appendTo( $container );

        // Add extra content.
        this.utils.renderExtra( this.$form, $container );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        if ( this.$form && this.$form.length ) {
            this.events();
        }
    }

}

// Export the class reference.
module.exports = Calculator3;



// WEBPACK FOOTER //
// ./assets/scripts/calculator3.js